import { SdkMessageTypes } from '../constants';
import { HostedWebContentSdkService } from '../hosted-web-content-sdk';
import { IAppInstallDialogService, ITelemetryService, OpenAppInstallDialogParams } from '../interfaces';
import { BaseMessageHandler } from './base-message-handler';
import { ILegacyLinkHandler } from './deep-link-message-handler';
import { onSdkError } from './messageHandlingUtils';

export class AppInstallDialogMessageHandler extends BaseMessageHandler {
  constructor(
    appSdkHost: HostedWebContentSdkService,
    protected appInstallDialogService?: IAppInstallDialogService,
    telemetryService?: ITelemetryService
  ) {
    super(appSdkHost, telemetryService);
  }

  public initHandlers(): void {
    this.registerHandler(
      SdkMessageTypes.appInstallDialog.openAppInstallDialog,
      (_, openAppInstallDialogParams: OpenAppInstallDialogParams) =>
        this.appInstallDialogService!.openAppInstallDialog(openAppInstallDialogParams),
      {
        errorCallback: (error, scenario) =>
          onSdkError(SdkMessageTypes.appInstallDialog.openAppInstallDialog, error, scenario),
      }
    );
  }

  protected validateDependencies(): void {
    if (!this.appInstallDialogService) {
      throw 'No appInstallDialogService provided';
    }
  }
}

export class AppInstallDialogLegacyLinkHandler implements ILegacyLinkHandler<OpenAppInstallDialogParams> {
  // This is looking for a URL with this pattern: "/l/app/<app id>/"
  private static readonly APP_INSTALL_DIALOG_URL_REGEX: RegExp = /^\/l\/app\/([^\/]+)\/?$/;

  constructor(private appInstallDialogService?: IAppInstallDialogService) {}
  public tryGetDataFromLink(url: URL): OpenAppInstallDialogParams | null {
    if (!this.appInstallDialogService) {
      return null;
    }
    if (url.origin != 'https://teams.microsoft.com') {
      return null;
    }
    const matches = url.pathname.match(AppInstallDialogLegacyLinkHandler.APP_INSTALL_DIALOG_URL_REGEX);
    if (!matches) {
      return null;
    }
    return {
      appId: matches[1],
    };
  }

  public executeData(ppenAppInstallDialogParams: OpenAppInstallDialogParams): Promise<void> {
    return this.appInstallDialogService!.openAppInstallDialog(ppenAppInstallDialogParams);
  }
}
